/** Foreground push and other live events ask open screens to refetch. */
type Listener = () => void;

const listeners = new Set<Listener>();

export function subscribeLiveRefresh(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitLiveRefresh(): void {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (err) {
      console.error('live refresh listener failed', err);
    }
  });
}
